import React, { useEffect, useState } from 'react';
import styles from './RelatedObjectsFilter.module.scss';
import { Dropdown, Tooltip } from 'antd';
import MyIcon from './components/MyIcon/MyIcon';
import { enumFilter } from './constanst';
import MenuFilter from './components/MenuFilter/MenuFilter';

const RelatedObjectsFilter = ({
  stageFilter,
  warFilter,
  selectedStageFilter = [],
  selectedWarFilter = [],
  handleChangeStageFilter,
  handleChangeWarrantyFilter,
}) => {
  const [visible, setVisible] = useState(false);
  const [selectedStage, setSelectedStage] = useState(selectedStageFilter);
  const [selectedWarranty, setSelectedWarranty] = useState(selectedWarFilter);

  const isActiveFilter =
    selectedStageFilter.length > 0 || selectedWarFilter.length > 0;

  const handleMenuClick = (key, field) => {
    if (field === enumFilter.STAGE) {
      setSelectedStage((prev) => {
        if (prev.includes(key)) {
          return prev.filter((k) => k !== key);
        } else {
          return [...prev, key];
        }
      });
      return;
    }

    setSelectedWarranty((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  const handleConfirm = () => {
    handleChangeStageFilter(selectedStage);
    handleChangeWarrantyFilter(selectedWarranty);
    setVisible(false);
  };

  const handleReset = () => {
    handleChangeStageFilter([]);
    handleChangeWarrantyFilter([]);

    setVisible(false);
  };

  useEffect(() => {
    setSelectedStage(selectedStageFilter);
  }, [selectedStageFilter]);

  useEffect(() => {
    setSelectedWarranty(selectedWarFilter);
  }, [selectedWarFilter]);

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      overlay={
        <MenuFilter
          selectedStage={selectedStage}
          selectedWarranty={selectedWarranty}
          stageFilter={stageFilter}
          warFilter={warFilter}
          onMenuClick={handleMenuClick}
          onConfirm={handleConfirm}
          onReset={handleReset}
        />
      }
      onVisibleChange={() => setVisible((prev) => !prev)}
      overlayClassName={styles.customDropdown}
    >
      <Tooltip title="Фильтр">
        <span className={styles.boxIcon}>
          <MyIcon
            bgColor={isActiveFilter ? '#0995ED' : 'white'}
            lineColor={isActiveFilter ? 'white' : '#0995ED'}
          />
        </span>
      </Tooltip>
    </Dropdown>
  );
};

export default RelatedObjectsFilter;
